import { registerAgGridModules } from "@platform/design-system";

import envVariables from "../projectEnvVariables";

export const registerGrid = (): void => {
  // Register AG Grid modules
  registerAgGridModules(envVariables.VITE_REACT_APP_AG_GRID_LICENSE_KEY || "");
};
